import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Typography from '../../../components/Typography';
import { i18nNS } from '../../../i18n';
import { TileDrawerButton } from '../styles';
import ClassList from './ClassList';
import { Content, tileClassesFormClasses } from './styles';
import useTileClassesForm, { UseTileClassesForm } from './vm';

export interface TileClassesFormProps extends UseTileClassesForm {
  className?: string;
  label?: string;
}

const TileClassesForm = ({ className, label, ...vmProps }: TileClassesFormProps) => {
  const { t } = useTranslation([i18nNS.SHARED, i18nNS.GLOSSARY]);

  const { selectedCourse, isFetchingClasses, classes, formMethods, onSubmit, onClose } =
    useTileClassesForm(vmProps);
  const { handleSubmit, control, formState } = formMethods;
  const { isValid, isSubmitting } = formState;

  return (
    <Stack gap={2} component="form" noValidate onSubmit={handleSubmit(onSubmit)} className={className}>
      <Content className={className}>
        <Typography variant="paragraphBold" component="h3">
          {t('select_a_class', { ns: i18nNS.SHARED })}
        </Typography>
        <Typography variant="paragraphRegular">
          {t('in_which_lecture_will_you_be_using_this_presentation', { ns: i18nNS.SHARED })}
        </Typography>
        <ClassList
          control={control}
          name="selectedClassId"
          isLoading={isFetchingClasses}
          selectedCourse={selectedCourse}
          classes={classes}
          className={tileClassesFormClasses.classList}
        />
      </Content>
      <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2} component="footer">
        <TileDrawerButton type="button" variant="text" onClick={onClose}>
          {t('cancel', { ns: i18nNS.GLOSSARY })}
        </TileDrawerButton>
        <TileDrawerButton type="submit" isLoading={isSubmitting} disabled={!isValid || isSubmitting}>
          {label || t('next', { ns: i18nNS.GLOSSARY })}
        </TileDrawerButton>
      </Stack>
    </Stack>
  );
};

export default TileClassesForm;
